import "./style.scss"
export const Loader=()=><div className="loading">Loading&#8230;</div>
